<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent="" scrollable  max-width="550px">
                <v-card>
                    <v-card-title id="membership_fee_payment_dialog_card_title">{{ formTitle }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="">
                        <br>
                        <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                        <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                        <v-form id="form_membership_fee_payment" ref="form" v-model="valid" lazy-validation>
                            <v-container>

                                <!-- data 
                                <v-row>
                                    <v-col>
                                        Naplata
                                    </v-col>
                                    <v-col>
                                        Znesek
                                    </v-col>
                                </v-row>-->

                                <!-- buttons -->
                                <v-row end class="" style="">
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> 
                                        <v-btn class="" block color="info" 
                                        @click="payment()"
                                        :loading="loadingPayment"
                                        :disabled="disableBtn ||disablePaymentBtn">
                                            Zavedi plačilo
                                        </v-btn>
                                    </v-col>

                                    <!--<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> 
                                        <v-btn block class="" color="success" 
                                        @click="printPaymentReceipt()"
                                        :loading="loadingPrintPayment"
                                        :disabled="disableBtn || deisablePaymentPrintBtn || !paymentDone || paymentId == null"
                                        >
                                            Natisni potrdilo
                                        </v-btn>
                                    </v-col>-->
                                    
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> 
                                        <v-btn block class="" color="success" 
                                        @click="printPaymentReceipt()"
                                        :loading="loadingPrintPayment"
                                        :disabled="disableBtn || deisablePaymentPrintBtn || !paymentDone || paymentId == null"
                                        >
                                            Natisni potrdilo
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> 
                                        <v-btn block class="" color="error" @click="cancel()" :disabled="disableBtn">{{ cancelText }}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
import { devicePlatform, rawBtPrint } from '@/helpers/services.js'
import { EventBus } from '@/main.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    name: 'membership-fee-payment-dialog',
    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({
        valid: true,
        formTitle: "Plačilo članarine",
        dialog: false,
        data: [],
        paymentData: null,
        loadingPayment:false,
        loadingPrintPayment: false,
        paymentDone: false,
        paymentId: null,
        disableBtn: false,
        disablePaymentBtn: false,
        deisablePaymentPrintBtn: false,
        cancelText: "Prekliči",

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],
        currentDate: null,

        timeoutVar: null,
        timeout1: null
    }),

    watch: {
        paymentId(value) {
            //window.console.log("paymentId: ", value)
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        }
    },

    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        payment() {
            let vm = this;
            /*vm.clearBackendMessages()
            clearTimeout(vm.timeoutVar)

            vm.disableBtn = true
            vm.loadingPayment = true

            vm.timeoutVar = setTimeout(() => {
                vm.disableBtn = false;
                vm.loadingPayment = false
                vm.cancelText = "Zaključi"

                vm.backendMessages.push('Plačilo članarine je bilo uspešno zavedeno.');
                vm.paymentDone = true
                vm.sendPaymentData({invoice_id: 1, success: true});

            }, 2000)*/

                vm.loadingPayment = true
                vm.backendValidationMessages = []
                vm.backendMessages = []
                vm.backendErrorMessages = []

                vm.$store.dispatch('CREATE_MEMBERSHIP_FEE_PAYMENT', vm.paymentData)
                .then(response => {
                    //window.console.log(response)
                    //window.console.log(response.data.data.id)
                    vm.backendMessages.push('Plačilo je bilo uspešno vneseno v sistem.');
                    vm.disablePaymentBtn = true
                    vm.cancelText = "Zaključi"
                    vm.paymentDone = true;
                    vm.paymentId = response.data.data.id

                })
                .catch(error => {
                    console.log('CREATE_MEMBERSHIP_FEE_PAYMENT error')
                    console.log(error)

                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... pri zapisovanju plačila je prišlo do napake. Poskusite ponovno.')
                    }

                })
                .finally(() => {
                    setTimeout(() =>{
                        vm.loadingPayment = false
                    },600)
                })



            
        },


        /*rawBtPrint(content) {
            var ua = navigator.userAgent.toLowerCase();
            window.console.log("Navigator User Agent: " + ua);
            var isAndroid = ua.indexOf("android") > -1; 

            if(isAndroid) {
                    //android_print(data);
                    window.location.href = content;
                    window.console.log("Android :-]");
            }else{
                //pc_print(data);
                var socket = new WebSocket("ws://127.0.0.1:40213/");
                    socket.bufferType = "arraybuffer";
                    socket.onerror = function(error) {
                    alert("Error");
                };			
                socket.onopen = function() {
                    socket.send(content);
                    socket.close(1000, "Work complete");
                    window.console.log("Work complete");
                };

                window.console.log("PC =)");
            }

            return 0;
        },*/


        printPaymentReceipt() {
            let vm = this;
            vm.loadingPrintPayment = true
            vm.backendValidationMessages = []
            vm.backendMessages = []
            vm.backendErrorMessages = []

            let printData = {
                payment_id: vm.paymentId,
                device_platform: devicePlatform()
            }


            vm.$store.dispatch('MEMBERSHIP_FEE_PAYMENT_PRINT', printData)
            //vm.$store.dispatch('TEST_PRINT')
            .then(response => {
                window.console.log(response)
                vm.backendMessages.push('Tisk potrdila je v teku ....');
                vm.disablePaymentBtn = true
                vm.cancelText = "Zaključi"
                vm.paymentDone = true;
                let rawBtContent = response.data.data

                //window.console.log(rawBtContent)

                if(rawBtContent !== "error" && rawBtContent !== null) {
                    //window.location.href = rawBtContent
                    //vm.rawBtPrint(rawBtContent)
                    rawBtPrint(rawBtContent)
                    window.console.log("print...")
                    window.console.log(rawBtContent)

                    vm.timeout1 = setTimeout(() => {
                        vm.backendValidationMessages = []
                        vm.backendMessages = []
                        vm.backendErrorMessages = []
                    }, 4000)
                    
                } else
                {
                    vm.backendErrorMessages.push('Ups... pri tiskanju potrdila o plačilu članarine je do napake. Poskusite ponovno.')
                }

            })
            .catch(error => {
                console.log('CREATE_MEMBERSHIP_FEE_PAYMENT error')
                console.log(error)

                if(error.response.status === 422) {
                    window.console.log(error.response.data.errors)
                    for (const property in error.response.data.errors) {
                        //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                        var propertyData = error.response.data.errors[property];
                        //window.console.log(propertyData);
                        propertyData.forEach(message => {
                            vm.backendValidationMessages.push(message);
                        })
                    }
                } else {
                    vm.backendErrorMessages.push('Ups... pri zapisovanju plačila je prišlo do napake. Poskusite ponovno.')
                }

            })
            .finally(() => {
                setTimeout(() =>{
                    vm.loadingPrintPayment = false
                },600)
            })
        },

        printPayment() {
            let vm = this;
            vm.clearBackendMessages();
            clearTimeout(vm.timeoutVar)

            vm.disableBtn = true
            vm.loadingPrintPayment = true

            vm.timeoutVar = setTimeout(() => {
                vm.disableBtn = false;
                vm.loadingPrintPayment = false
                vm.cancelText = "Zaključi"


               var content2 = "intent:base64,G0AddjAAMADWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA///gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB///4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH///+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP///+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/////4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/////+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/////+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA///////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB///////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB///////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///////4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH///////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP///7///+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP///x////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf///w////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA////g////gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA////gf///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB////Af///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB////AP///4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///+AP///4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH///+AH///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH///8AH///+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP///8AD///+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAP///4AD////AAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAf///4AB////AAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHgAA////wAB////gAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHgAA////wAA////wAA8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPwAB////gAA////wAB+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf4AD////gAAf///4AB/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAf8AH////AAAf///+AD/gBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcB/+Af///+AAAP////AP/wDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfH//h////+AAAH////4//8PAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf////////8AAAH/////////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf////////8AAAD/////////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf////////4AAAB/////////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/8///n//4AAAA//8f//n//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/4f//D//wAAAAf/4P//B//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/gH/8A//AAAAAP/gD/8A//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+AA/gAP4AAAAAD+AAfwAH4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwMAAAAAAAAAAAAAAAAAAAAAAMDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwcAAAAAAAAAAAAAAAAAAAAAAODgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB48AAAAAAAAAAAAAAAAAAAAAAOHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA84AAAAAAAAAAAAAAAAAAAAAAHHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAd4AAAAAAAAAAAAAAAAAAAAAAHuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf4AAAAAAAAAAAAAAAAAAAAAAH+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfwAAAAAAAAAAAAAAAAAAAAAAD+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPwAAAAAAAAAAAAAAAAAAAAAAD8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8HgHwH8AA8Af4f/+DwAP8BwB4AD+AAAA/4AA/wAHgHwB/D//z4B4B/AAAAAAAA//+HgHwP/AB+A/4///H4Af+D4B4AP/AAAA/+AA/8AHwHwD/j//78D8D/wAAAAAAA//+HgHwP/gB+B/4///H4A/+D4B4Af/gAAA//AA/+AHwHwH/j//78D8H/4AAAAAAA//+HgHwP/wB+D/4///H4B/+D8B4Af/wAAA//wA//AHwHwP/j//58D4H/8AAAAAAA//8HgHwP/4B+D8Yf/+H4D+eD8B4A/PwAAA//wA//AHwHwfxD//x8D4Pz8AAAAAAAA+AHgHwPn8B+D4AA+AH4D4CD8B4B+H4AAA8H4A+fgHwHwfAAD4B8D4fh+AAAAAAAA+AHgHwPh8B+HwAA+AH4HwAD8B4B8D4AAA8D8A+PgHwHwfAAD4B8D4fA+AAAAAAAA+AHgHwPh8B+HwAA+AH4HwAD+B4B8B8AAA8B8A+HwHwHweAAD4B8HwfAfAAAAAAAA+AHgHwPg8B+HwAA+AH4PgAD+B4D4B8AAA8A+A+HwHwHweAAD4B+Hw+AfAAAAAAAA+AHgHwPg+B+HwAA+AH4PwAD+B4D4B8AAA8A+A+HwHwHwfAAD4B8Hw+AfAAAAAAAA+AHgHwPg+B+HwAA+AH4PgAD/B4H4B8AAA8A+A+HwHwHwfAAD4A+Hw+AfAAAAAAAA+AHgHwPg+B+D4AA+AH4PgAD/B4H4B+AAA8AfA+HwHwHwfAAD4A+Hg8APgAAAAAAA+AHgHwPg+B+D4AA+AH4PgAD/B4HwA+AAA8AfA+HwHwHwfgAD4A+Hh8APgAAAAAAA+AHgHwPh8B+D8AA+AH4PgAD/h4H4A+AAA8AfA+HwHwHwfgAD4A+Ph8APgAAAAAAA+AHgHwPh8B+B8AA+AH4PgAD/h4H4A+AAA8AfA+HwHwHwPwAD4AePh8APgAAAAAAA+AHgHwPh8B+B+AA+AH4fgAD/x4HwA+AAA8AfA+PgHwHwPwAD4AePh8APgAAAAAAA+AHgHwPn4B+B+AA+AH4fgAD/x4HwA+AAA8AfA+fgHwHwH4AD4AfPh8APwAAAAAAA+AHgHwP/wB+A/AA+AH4fgAD7x4HwA+AAA8AfA//AHwHwH4AD4AfPB8APwAAAAAAA+AHgHwP/gB+A/AA+AH4fgAD754HwA+AAA8AfA/+AHwHwD8AD4AfPB8APwAAAAAAA+AHgHwP/gB+AfgA+AH4fgAD554HwA+AAA8AfA/+AHwHwD8AD4AfPB8APwAAAAAAA+AHgHwP/wB+AfgA+AH4fgAD554HwA+AAA8AfA/+AHwHwB+AD4AfPB8APwAAAAAAA+AHgHwP/4B+APwA+AH4fgAD594HwA+AAA8AfA+/AHwHwB+AD4AfPB8APwAAAAAAA+AHgHwPj4B+APwA+AH4fgAD4/4HwA+AAA8AfA+fgHwHwA/AD4APeB8APwAAAAAAA+AHgHwPh8B+AH4A+AH4fgAD4/4HwA+AAA8AfA+PgHwHwA/AD4AP+B8APgAAAAAAA+AHgHwPh8B+AH4A+AH4fgAD4/4H4A+AAA8AfA+PwHwHwAfgD4AP+B8APgAAAAAAA+AHgHwPh8B+AD4A+AH4PgAD4f4H4A+AAA8AfA+HwHwHwAfgD4AP+B8APgAAAAAAA+AHgHwPg+B+AD8A+AH4PgAD4f4HwA+AAA8AfA+HwHwHwAPgD4AH+B8APgAAAAAAA+AHgHwPg+B+AB8A+AH4PgAD4f4D4B+AAA8AfA+H4HwHwAPgD4AH+A8APgAAAAAAA+AHgHwPg/B+AB8A+AH4PgAD4P4H4B+AAA8A+A+D4HwHwAHgD4AH8A+AfgAAAAAAA+AHgHwPgfB+AB8A+AH4PwAD4P4D4B8AAA8A+A+D4HwHwAHwD4AH8A+AfAAAAAAAA+AHwHwPgfB+AA8A+AH4PwAD4P4D4B8AAA8A+A+D4HwHwAHwD4AH8A+AfAAAAAAAA+AHwHwPgfB+AA8A+AH4HwAD4H4B8D8AAA8B8A+D8HwHwAHwD4AD8AeAfAAAAAAAA+AHwPgPgfB+AB8A+AH4HwAD4H4B8D4AAA8D8A+B8HwPgAHgD4AD8AfA+AAAAAAAA+AH4PgPgfh+AB8A+AH4D4HD4D4A+H4AAA8P4A+B8H4PgAPgD4AD4Afh+AAAAAAAA+AD//gPgPh+Df4A+AH4D//D4D4A/fwAAA//wA+B+D//gf/gD4AD4AP78AAAAAAAA+AD//APgPh+D/4A+AH4B//D4D4Af/wAAA//wA+B+D//Af/AD4AD4AP/4AAAAAAAA+AB/+APgPh+D/wA+AH4A//D4D4AP/gAAA//AA+A+B/+Af/AD4AB4AH/4AAAAAAAA+AA/8APgPx+D/gA+AH4Af+D4B4AH/AAAA/+AA+A+A/8Af+AD4AB4AD/wAAAAAAAA8AAP4AHgHg8B/AAeADwAP4B4B4AD8AAAA/4AA8A+AP4AP4ADwABwAA/AAAAAAAAAAAADAAAAAAAAYAAAAAAABgAAAAAAwAAAAAAAAAAAADAABgAAAAAwAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAP/wAPgAPwD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4A/wAf8D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4B/wA/+D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4D/wB/+D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4D8wD+eD/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfgAHwAD4EDwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAHwADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAHwADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAPgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAPgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAPgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAHwAPAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAH4APAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAH4AfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAD4AfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfgAD8AfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/gB+AfAAD/4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4B+AfAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4A/AfAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4A/AfAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAf/4AfgfAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfgAAfgfAAD4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAPgfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAPwfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAHwfAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAH4fAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAD4fAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAD4PAADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAB4PgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAB8PgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAB8PgADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAB4HwADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfAAAB4HwADwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAfgAED4H4GDwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8f/4HP4D+eD/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8f/8H/wB/+D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8f/8H/gA/+D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8f/8H/AAf8D/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/4H/wB+AAHwD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABthAUFscHNrYSBjZXN0YSA1OAo0MjQ4IExlc2NlClRlbC46IDA0IDUzMTU0NjcKRS1tYWlsLjogaW5mb0B0ZC1sZXNjZS5zaQpEYXYbdBKfbmEg53Rldmlsa2E6IDg1OTgwNDA0ChshAAoKG0UBUG90cmRpbG8gbyBwbGGfaWx1IJ9sYW5hcmluZQpQb3RyZGlsbyDndC46IDEKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KG0UAG2EAG0UBG0UAMXggU3RhbmRhcmRuYSCfbGFuYXJpbmEgemEgb2RyYXNsZWdhIGl6IExlc2MgICAzLDAwG3QQgAoxeCBPdHJvmmthIBt0Ep9sYW5hcmluYSB6YSBvdHJva2EgaXogTGVzYyAgIDMsMDAbdBCACi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tG0UAChthAFNrdXBhaiB6YSBwbGEbdBKfaWxvICAgICAgICAgIDYsMDAbdBCAChshABthAQpPcGVyYXRlcjogTGVuG3QSnyBTa3VtYXZlYwpEYXR1bSBpbiCfYXMgcGxhn2lsYTogMjMuMDMuMjAyMiAxMzo0Njo1MApJemJyYW5vIGxldG86IDIwMjIKUGxhn25pazogTGVunyBTa3VtYXZlYwobYQEKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KaHR0cHM6Ly93d3cudGQtbGVzY2Uuc2kKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KHVZBAxtwMDx4#Intent;scheme=rawbt;package=ru.a402d.rawbtprinter;end;"
                
                //window.location.href = content2;
                var ua = navigator.userAgent.toLowerCase();
                window.console.log("Navigator User Agent: " + ua);
                var isAndroid = ua.indexOf("android") > -1; 
                
                /*
                if(isAndroid) {
                    //android_print(data);
                    window.location.href = content2;
                    window.console.log("Android :-]");
                }else{
                    //pc_print(data);
                    var socket = new WebSocket("ws://127.0.0.1:40213/");
                        socket.bufferType = "arraybuffer";
                        socket.onerror = function(error) {
                        alert("Error");
                    };			
                    socket.onopen = function() {
                        //socket.send(content2);
                        socket.send("intent:base64,G0AbYQFBbHBza2EgY2VzdGEgNTgKNDI0OCBMZXNjZQpUZWwuOiAwNCA1MzE1NDY3CkUtbWFpbC46IGluZm9AdGQtbGVzY2Uuc2kKRGF2G3QSn25hIOd0ZXZpbGthOiA4NTk4MDQwNAobIQAKChtFAVBvdHJkaWxvIG8gcGxhn2lsdSCfbGFuYXJpbmUKUG90cmRpbG8g53QuOiAxCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tChtFABthABtFARtFADF4IFN0YW5kYXJkbmEgn2xhbmFyaW5hIHphIG9kcmFzbGVnYSBpeiBMZXNjICAgMywwMBt0EIAKMXggT3Ryb5prYSAbdBKfbGFuYXJpbmEgemEgb3Ryb2thIGl6IExlc2MgICAzLDAwG3QQgAotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLRtFAAobYQBTa3VwYWogemEgcGxhG3QSn2lsbyAgICAgICAgICA2LDAwG3QQgAobIQAbYQEKT3BlcmF0ZXI6IExlbht0Ep8gU2t1bWF2ZWMKRGF0dW0gaW4gn2FzIHBsYZ9pbGE6IDI5LjAzLjIwMjIgMDc6NDY6MDEKSXpicmFubyBsZXRvOiAyMDIyClBsYZ9uaWs6IExlbp8gU2t1bWF2ZWMKG2EBCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCmh0dHBzOi8vd3d3LnRkLWxlc2NlLnNpCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCh1WQQMbcDA8eA==#Intent;scheme=rawbt;package=ru.a402d.rawbtprinter;end;");
                        socket.close(1000, "Work complete");
                        window.console.log("Work complete");
                    };

                    window.console.log("PC =)");
                }
                */

                /*var S = "#Intent;scheme=rawbt;";
                var P =  "package=ru.a402d.rawbtprinter;end;";

                var content2 ="\n";
                content2 += "--------------------------------\n             WRAAAH            \n--------------------------------";

                var textEncoded = encodeURI(content2);
                location.href="intent:"+textEncoded+S+P;*/

                vm.backendErrorMessages.push('Ups... Pri tiskanju potrdila o plačilu je prišlo do napake. Poskusite ponovno.');
                vm.sendPaymentData({invoice_id: null, success: false})
                


            }, 2000)
        },

        sendPaymentData(data) {
            EventBus.$emit('MEMBERSHIP_FEE_PAYMENT_CONFIRMATION', data);
        },

        cancel() {
            this.clearBackendMessages()
            this.data = []
            this.paymentData = null
            this.dialog = false;
            this.cancelText = "Prekliči"
            this.disableBtn = false
            //this.paymentDone = false //
            this.disablePaymentBtn = false
            this.deisablePaymentPrintBtn = false
            //EventBus.$emit('refresh_dt_events', null)
            EventBus.$emit('MEMBERSHIP_FEE_PAYMENT_DIALOG_CLOSE', {
                paymentDone: this.paymentDone
            });

            this.$nextTick(() => {
                this.paymentDone = false
                this.paymentId = null
            });
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },
    },

    created() {
        var vm = this;
        this.currentDate = getCurrentDate()
        //vm.paymentId = 10;

        EventBus.$on('MEMBERSHIP_FEE_PAYMENT_DIALOG', function(data) {
            //window.console.log("### MembershipFeePayment@MEMBERSHIP_FEE_PAYMENT_DIALOG event ###");
            vm.paymentData = data;
            vm.dialog = true;
            //window.console.log(data)
        });
    },

    mounted() {

    },

    beforeDestroy() {
        clearTimeout(this.timeoutVar)
        clearTimeout(this.timeout1)
    },

    destroyed() { 
        EventBus.$off('MEMBERSHIP_FEE_PAYMENT_DIALOG')
    }
}

</script>

<style scoped>
    #membership_fee_payment_dialog_card_title {
        background-color: #F5F5F5;
        font-weight:400;
    }
</style>